module.exports = __webpack_public_path__ + "img/detail-popup-hen.b30736f4.png";